import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Card, CardBody, CardHeader } from '@heroui/react';

const Privacy = () => {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-gray-900 justify-center items-center p-4">
      <Card className="w-full p-8 md:p-12 rounded-lg shadow-2xl max-w-2xl bg-white/95 backdrop-blur-sm">
        <CardHeader className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-800">Privacy Policy</h2>
        </CardHeader>
        <CardBody>
          <div className="prose max-w-none">
            <ReactMarkdown>
              {`This privacy policy describes how your personal information is handled in our application. We are committed to protecting your privacy and ensuring the security of your information.

## Information We Collect
We do not store any of your data locally. All data is processed locally on your device. We do not collect any personal information from you, except for the information you provide when logging in and logging out.

## How We Use Your Information
The personal information you provide when logging in and logging out is only used to authenticate your account and to provide you with access to our application. We do not use your personal information for any other purpose. We do not sell your personal information to third parties.

## Data Security
We take data security seriously. Data sent to LLM's is encrypted using industry-standard encryption protocols. We also implement a variety of security measures to protect your personal information from unauthorized access, use, or disclosure.

## Your Rights
You have the following rights regarding your personal information:
- The right to access your personal information.
- The right to correct your personal information.
- The right to delete your personal information.
You can exercise these rights by contacting us.

## Contact Us
If you have any questions about this privacy policy, please contact us.`}
            </ReactMarkdown>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Privacy;
